@for (source of sources(); track source) {
    @let previewAvailable = isSourcePreviewAvailable(source);
    @let pending = isSourcePending(source);
    <button
        class="no-disabled-color label-truncate min-w-0 max-w-64 overflow-hidden px-2!"
        qpxButton
        qpxQuippySourceHover
        [documentId]="source.id"
        [buildingName]="sourceBuildingName(source)"
        [buildingId]="source.buildingId ?? sourceFallbackBuildingId()"
        [matButton]="appearance() === 'outlined' ? 'outlined' : 'elevated'"
        size="sm"
        [disabled]="!previewAvailable || pending"
        [attr.aria-busy]="previewAvailable ? pending : null"
        [attr.aria-label]="
            previewAvailable
                ? `Open source: ${sourceLabel(source)}`
                : `Preview unavailable for source: ${sourceLabel(source)}`
        "
        (click)="openSourcePreview(source)"
    >
        @if (sourceFileName(source).badge; as badge) {
            <qpx-file-type-icon
                matButtonIcon
                appearance="boxed"
                size="sm"
                tone="muted"
                style="--qpx-file-type-icon-min-size: 24px"
                [extension]="badge.label"
            />
        }
        <span class="block min-w-0 max-w-44 truncate">
            {{ sourceFileName(source).title }}
        </span>
        @if (!previewAvailable) {
            <span aria-hidden="true" class="shrink-0 font-normal"
                >(Preview unavailable)</span
            >
        }
    </button>
}
